
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { mapState } from 'vuex'
export default {
name: 'medicalDate',
props: [],
components: {
XHeader,
Group,
Cell
},
data () {
return {
dateArr: []
}
},
computed: {
...mapState({
title: state => state.currentProcedureInfo.name,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId
})
},
created () {},
mounted () {
this.getTimeSlot()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
goMedical (id, flag) {
if (flag) {
this.$router.replace({
name: 'medical',
params: { dateId: id }
})
}
},

getTimeSlot () {
let params = {
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId
}
this.$api.get('/configBodyExam', params,
r => {
r.data.forEach(element => {
let obj = {}
let isfull = ''
let flag = false
if (element.totalNumber - element.useNumber === 0) {
isfull = ' 名额已满'
flag = false
} else {
isfull = '可预约'
flag = true
}
obj = {
'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
'state': isfull,
'num': element.totalNumber - element.useNumber,
'id': element.id,
'flag': flag
}
this.dateArr.push(obj)
})
this.dateArr = this.dateArr.sort(this.sortNumber)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

sortNumber (a, b) {
return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0])
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/medical/medicalDate.vue